import { render, staticRenderFns } from "./NCAdminResponses.vue?vue&type=template&id=61d53d70&scoped=true&"
import script from "./NCAdminResponses.vue?vue&type=script&lang=js&"
export * from "./NCAdminResponses.vue?vue&type=script&lang=js&"
import style0 from "./NCAdminResponses.vue?vue&type=style&index=0&id=61d53d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d53d70",
  null
  
)

export default component.exports